interface Item<T, K extends keyof T, V = T[K]> {
  key: K;
  value: V;
}
type Mapper<I, R> = (item: I, index: number, array: I[]) => R;

//

function oMap<T extends Record<K, T[K]>, K extends keyof T, I = Item<T, K>, R = I>(
  object: T,
  mapper: Mapper<I, Promise<R>>,
): Promise<R[]>;

function oMap<T extends Record<K, T[K]>, K extends keyof T, I = Item<T, K>, R = I>(
  object: T,
  mapper: Mapper<I, R>,
): R[];

function oMap<T extends Record<K, T[K]>, K extends keyof T, I = Item<T, K>, R = I>(
  object: T,
  mapper: Mapper<I, R>,
): Promise<R[]> | R[] {
  const array = Object.entries(object).map(
    ([key, value]) =>
      ({
        key,
        value,
      }) as I,
  );
  const result = array.map(mapper);
  if (result.at(0) instanceof Promise) return Promise.all(result);
  return result;
}

//

export default oMap;
